<script setup lang="ts">
import TimelineScorecard from '../TimelineScorecard.vue'
import { Timesheets } from '../../types/timers'
import { computed, ref } from 'vue'
import BaseModal from '../wrappers/BaseModal.vue'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import { useExpenses, formatExpensesForTable } from '../../store/useExpenses'
import { Table } from '../../types/components/data-rendering'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  timesheets: Timesheets
}>()

//translations
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`payPeriod.${key}`)
const form = (key: string) => t(`form.${key}`)

const totalExpenses = computed(() => {
  return props.timesheets
    .reduce((acc, timesheet) => {
      return acc + timesheet.expenses
    }, 0)
    .toLocaleString(undefined, { style: 'currency', currency: 'USD' })
})
const { getExpensesByDateRange } = useExpenses()
const expenses = computed((): Table => {
  if (!props.timesheets.length) return { meta: {}, data: [] }
  const start = new Date(props.timesheets[props.timesheets.length - 1].date)
  const end = new Date(props.timesheets[0].date)
  //needs to be end of the day, otherwise potential current day is excluded
  end.setHours(23)
  end.setMinutes(59)
  const data = getExpensesByDateRange({ start, end })
  return formatExpensesForTable(data)
})

const value = ref(false)
</script>
<template>
  <TimelineScorecard @click="value = true" :header="label('expenses')" :subheader="totalExpenses" />
  <BaseModal v-model="value">
    <template #title>{{ `${form('total')} ${label('expenses')}: ${totalExpenses}` }}</template>
    <template #content>
      <FilteringDataDisplay :table-data="expenses" :enable-filters="false" />
    </template>
    <template #actions>
      <q-btn rounded flat :label="form('close')" v-close-popup />
    </template>
  </BaseModal>
</template>
